<template>
  <div class="quiz-container">
    <div class="quiz-header">
      <div class="header"  :style="quizMessage" >{{quizName}}</div>
    </div>
    <div class="completed-card">
      <div class="box" :style="boxSettings">
        <div class="tileee is-size-4"  :style="quizMessage" >{{promoText}}</div>
        <hr :style="hrMargin"/>
       
        <div class="score-list">
         
          <div class="leadership-badge my-4">
            <figure class="image imageLogo mt-2">
              <img class="is-rounded imageWidth" :src="logo" />
            </figure>
          </div>
           <div class="leadership-rank-title is-size-6 mt-3"><a :href="quizUrl+'/leaderboard'" target="_blank"><button class="button" :style="buttonSettings">Leaderboard</button></a></div>
           <br />
           
           
          <div class="score-details">
            <span class="score-label is-size-6"  :style="quizMessage" >Total Questions</span>
            <span class="score-detail is-size-6" :style="quizLoginSettings" >{{ totalQuestions }}</span>
          </div>
          <div class="score-details">
            <span class="score-label is-size-6"  :style="quizMessage" >Correct Answers</span>
            <span class="score-detail is-size-6" :style="quizLoginSettings" >{{ correctAns }}</span>
          </div>
          <div class="score-details">
            <span class="score-label is-size-6"  :style="quizMessage">Time Taken</span>
            <span class="score-detail is-size-6" :style="quizLoginSettings" >{{ formattedElapsedTime }}</span>
          </div>
        </div>
        <br />
        <div class="social-share mt-3">
          <div class="paddingSocialMedia">  <a :href="facebookLink" target="_blank"> <i class="fa fa-facebook-square socialIcon" :style="quizLoginSettings"> </i>  </a> </div>
          <div class="paddingSocialMedia"> <a :href="linkedinLink" target="_blank"> <i class="fa fa-linkedin socialIcon" :style="quizLoginSettings"> </i>  </a> </div>
          <div class="paddingSocialMedia"> <a :href="twitterLink" target="_blank">  <i class="fa fa-twitter socialIcon" :style="quizLoginSettings"> </i> </a> </div>
           
        </div>
      </div>
          </div>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Instructions',
  computed: {
    ...mapGetters(['formattedElapsedTime', 'score', 'correctAns', 'totalQuestions' , 'quizUrl', 'quizName',  'promoText', 'facebookLink', 'linkedinLink', 'twitterLink', 'logo', 'backgroundColor', 'primaryColor', 'textColor']),
     boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    hrMargin(){
      return{
        "background-color": this.primaryColor
      }

    }, 
    buttonSettings(){
      return{
        "background-color": this.primaryColor,
        "border-color": this.primaryColor,
        "color": this.textColor
      }
    },
    quizLoginSettings(){
      return{
        "color": this.textColor
        
      }
    },
    quizMessage(){
      return{
        "color": this.primaryColor
        
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.quiz-container {
  width: 100vw;
  height: 100vh;
  background-color: $app-background-color;

  .quiz-header {
    display: flex;
    justify-content: center;

    .header {
      font-size: 40px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
    }
  }

  .completed-card {
    display: flex;
    justify-content: center;
    place-items: center;

    .box {
      background-color: $box-background-color;
      border-radius: 1.56rem;
      padding: 15px;
      max-width: 30rem;
      width: 30rem;
      min-height: 30rem;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      align-items: unset;

      .paddingSocialMedia{
        padding: 15px;
      }

      .socialIcon{
        color: white;
        font-size: 1.5rem;
      }

      .tileee {
        font-weight: bold;
        line-height: 30px;
        color: $primary-color;
        padding: 0.5rem;
        overflow: hidden;
        display: inline-table;
        align-self: center;
        text-align: center;
      }
      hr {
        background-color: $primary-color;
        border-radius: 25px;
        margin: 0rem;
      }

      .score-list {
        display: flex;
        flex: 0 0 85%;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
        color: $primary-color;
        align-self: center;
        width: 100%;
        padding: 0px 10%;

        .imageLogo{
          
          .imageWidth{
          width: 125px;
          height: 100px;
        }
        }

        .leadership-rank-title {
          align-self: center;
          color: $brand-color;
        }
        .leadership-badge {
          align-self: center;
          display: inline-block;
          position: relative;

          .centered {
            position: absolute;
            // margin-top: -1.75%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-weight: bold;
          }
        }

        .score-details {
          display: flex;
          justify-content: space-between;

          .score-detail {
            color: $brand-color;
          }
        }
      }

      .social-share {
        display: flex;
        justify-content: center;
        align-items: center;
        .social-icons {
          justify-content: space-between;
          a {
            color: $brand-color;
            &:hover {
              color: $brand-color;
            }
          }
        }
      }
    }
  }
}
</style>
